"use client";

import React from "react";

const options = [
  {
    title: "Fast-track Option",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cpa-course/fast_track_option.webp",
    description: "Complete all 4 exams in 12–16 months with guided mentoring",
  },
  {
    title: "Flexible Learning",
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cpa-course/flexible_learning.webp",
    description: "Online & weekend options to suit your pace",
  },
];

// White card body outline (with the folder-tab notch at the top-left).
// The animated border that traces this same outline lives in globals.css (.cpa-anim-border).
const FILL_PATH =
  "M14 47.6297C14 40.0357 20.1561 33.8797 27.75 33.8797H31.5602C37.0498 33.8797 41.5 29.4294 41.5 23.9398C41.5 18.4502 45.9502 14 51.4398 14L220.06 14C225.55 14 230 18.4502 230 23.9398C230 29.4294 234.45 33.8797 239.94 33.8797L359 33.8797C366.732 33.8797 373 40.1477 373 47.8797V280C373 287.732 366.732 294 359 294H28C20.268 294 14 287.732 14 280L14 47.6297Z";

const CardFrame = () => (
  <svg
    className="absolute inset-0 w-full h-full [filter:drop-shadow(0_0_14px_rgba(0,0,0,0.05))]"
    viewBox="0 0 387 308"
    preserveAspectRatio="none"
    fill="none"
    aria-hidden="true"
  >
    <path d={FILL_PATH} fill="white" />
  </svg>
);

const CPACourseDuration = () => {
  return (
    <section className="w-full bg-[#F4F4F4] md:bg-white pt-4 md:py-[50px]">
      <div className="main_container mx-auto px-4 md:px-8">
        {/* On mobile: white rounded card holding the whole block; on desktop: plain */}
        <div className="bg-white rounded-[16px] px-2 py-4 md:bg-transparent md:rounded-none md:p-0">
          {/* Heading */}
          <div className="text-left mb-4 md:mb-8 md:text-center md:px-0 px-2">
            <h2 className="text-2xl md:text-[32px] font-bold md:text-[#333333] text-[#1D1D1D] md:leading-normal leading-[1.2]">
              Understanding the
              <br className="md:hidden block" />{" "}
              <span className="text-[#39F]">CPA</span> Duration
            </h2>
            <p className="mt-6 md:mt-8 text-black text-[12px] md:text-[14px] leading-relaxed max-w-[560px] mx-auto">
              You can complete the exams in 12–16 months, even while
              <br className="md:hidden block" /> working full-time.
            </p>
          </div>

          {/* Cards grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-6 max-w-[800px] mx-auto">
            {options.map((option, idx) => (
              <div key={idx} className="relative w-full">
                {/* White card body + shadow */}
                <CardFrame />

                {/* Animated conic-gradient border (follows the tab-notch outline) */}
                <span className="cpa-anim-border" aria-hidden="true" />

                {/* Title sits inside the folder tab */}
                <h3 className="absolute top-[5.2%] left-[14%] z-10 text-[#0B2A4D] font-semibold text-[14px] md:text-[16px]">
                  {option.title}
                </h3>

                {/* Card content */}
                <div className="relative z-10 px-[22px] md:px-8 pt-[46px] md:pt-[52px] pb-[26px]">
                  <div className="overflow-hidden rounded-[14px]">
                    <img
                      src={option.image}
                      alt={option.title}
                      loading="lazy"
                      className="w-full h-[185px] md:h-[160px] object-cover"
                    />
                  </div>
                  <p className="mt-4 text-black text-[12px] md:text-[14px] leading-relaxed md:leading-[20px]">
                    {option.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CPACourseDuration;
